import { constants, Stack, Text } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { useOpenModal } from '@redbubble/next/modals';
import React from 'react';

import { SelectCountry } from './SelectCountry';
import styles from './Shipping.module.scss';

interface DeliveryToProps {
  countryName: string;
}

const messages = defineMessages({
  deliveryTo: {
    defaultMessage: 'Delivery to <bold>{countryName}</bold>',
  },
  changeDeliveryCountryButton: {
    defaultMessage: 'Change',
  },
  selectCountryTitle: {
    defaultMessage: 'User Settings',
  },
});

const bold = (str) => <b>{str}</b>;

export const DeliveryTo = ({ countryName }: DeliveryToProps) => {
  const intl = useIntl();
  const openModal = useOpenModal();

  return (
    <Stack direction={constants.HORIZONTAL} justifyContent="space-between">
      <Text type="body">
        {intl.formatMessage(messages.deliveryTo, {
          countryName,
          bold,
        })}
      </Text>

      <button
        type="button"
        className={styles.changeDeliveryCountryButton}
        onClick={() => {
          openModal({
            accessibleTitle: intl.formatMessage(messages.selectCountryTitle),
            content: <SelectCountry />,
          });
        }}
      >
        {intl.formatMessage(messages.changeDeliveryCountryButton)}
      </button>
    </Stack>
  );
};
